import { ComponentProps, memo } from "react";

import { Plate } from "@/components/@custom/Plate";
import { ExpeditionDate } from "@/features/expedicao/components/ExpeditionDate";
import { cn } from "@/utils/cn";
import { omitClassNameFromProps } from "@/utils/omit";

interface ExpeditionQueueListItemBaseProps {
  driverName: string;
  components?: {
    Actions?: React.ReactNode;
    DriverInfo?: React.ReactNode;
    Bottom?: React.ReactNode;
  };
  slots: {
    DriverInfoWrapper?: ComponentProps<"div">;
    Actions?: ComponentProps<"div">;
    Wrapper?: ComponentProps<"div">;
    Plate: ComponentProps<typeof Plate>;
    ExpeditionDate: ComponentProps<typeof ExpeditionDate>;
    DriverWrapper?: ComponentProps<"div">;
  };
}

export const ExpeditionQueueListItemBase = memo(({ driverName, slots, components }: ExpeditionQueueListItemBaseProps) => {
  return (
    <div className={cn("flex items-center justify-between gap-4 py-2", slots?.Wrapper?.className)} {...omitClassNameFromProps(slots?.Wrapper ?? {})}>
      <div className={cn("flex flex-1 gap-2", slots?.DriverWrapper?.className)} {...omitClassNameFromProps(slots?.DriverWrapper ?? {})}>
        <ExpeditionDate {...slots?.ExpeditionDate} />
        <Plate {...slots?.Plate} />

        <div
          className={cn("flex flex-col justify-center gap-2 text-sm leading-none text-gray-700", slots?.DriverInfoWrapper?.className)}
          {...omitClassNameFromProps(slots?.DriverInfoWrapper ?? {})}
        >
          <p className="font-semibold">{driverName}</p>
          {components?.DriverInfo}
        </div>
      </div>

      {components?.Bottom}

      {components?.Actions && (
        <div className="flex gap-1" {...slots?.Actions}>
          {components.Actions}
        </div>
      )}
    </div>
  );
});
ExpeditionQueueListItemBase.displayName = "ExpeditionQueueListItemBase";
